<template>
<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_247_2267)">
<path d="M8.20712 7.8229C7.88098 8.13152 7.44902 8.3035 7.00001 8.3035C6.551 8.3035 6.11904 8.13152 5.7929 7.8229L0.689121 2.95557C0.619788 3.12656 0.58388 3.30927 0.583344 3.49379V10.4938C0.583754 10.8804 0.7374 11.251 1.01061 11.5245C1.28382 11.798 1.65431 11.9521 2.0409 11.9529H11.9591C12.3457 11.9521 12.7162 11.798 12.9894 11.5245C13.2626 11.251 13.4163 10.8804 13.4167 10.4938V3.49379C13.4161 3.30927 13.3802 3.12656 13.3109 2.95557L8.20712 7.8229Z" fill="white"/>
<path d="M6.19578 7.39978C6.41633 7.59949 6.70324 7.71009 7.00078 7.71009C7.29831 7.71009 7.58522 7.59949 7.80578 7.39978L12.9858 2.46556C12.713 2.19401 12.344 2.04135 11.9591 2.04089H2.04089C1.65602 2.04135 1.28696 2.19401 1.01422 2.46556L6.19578 7.39978Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_247_2267">
<rect width="14" height="14" fill="white"/>
</clipPath>
</defs>
</svg>
</template>